import { Component,  BaseTLTableComponent, AxiosResponse, EnumsFilter, EnumsService, EnumsGroupsFilter, EnumsGroupsService, Vue } from "../../../Infrastructure/CorBase/CoreBase";
  
		export default abstract class EnumListBase extends BaseTLTableComponent {

			enumsService: EnumsService = new EnumsService();
			enumsGroupsService: EnumsGroupsService = new EnumsGroupsService();
			enums: any[] = [];

			description: string = ' ';
			enumsGroups = [{ id: '', order: 0, identifier: '', name: '', description: '', isEditable: true }];

			isEditable = false;
			selectedIdentifier = '';
			defaultEnum = '';

			showButtonUpdate() {
				return this.isEditable && this.canUpdate;
			}


			showButtonDelete() {
				this.selectedIdentifier = this.filters.filter((c: any) => c.key == 'groupIdentifier')[0].value;
				this.isEditable = this.enumsGroups.filter((c: any) => c.identifier == this.selectedIdentifier).length > 0 ? this.enumsGroups.filter((c: any) => c.identifier == this.selectedIdentifier)[0].isEditable : false;

				if (this.isEditable) {
					this.fields.filter((c: any) => c.key == 'order')[0].class = 'text-center, visibility: visible';
				}
				else {
					this.fields.filter((c: any) => c.key == 'order')[0].class = 'text-center, visibility: collapse';
				}
				return this.canDelete && this.isEditable;
			}


			formData = {
				id: 0 as number,
				idTenant:0 as number ,
				idGroup: 0 as number,
				name: '' as string,
				description: '' as string,
				identifier: '' as string,
				order: null,
				reorder: true
			};

			itemsDropDown = [];


			showAllertToDeleteClick(itemsSelected: any) {
				super.showAlertBeforeActionClickBase(itemsSelected, this.$t('enum.messageQuestionMain').toString(), true);
			}

			callActionClick() {
				this.isBusy = true;
				this.enumsService.delete(this.itemsSelected).then(() => this.fetchData()).catch(error => {
					var errorMessage = this.$t('enum.errorDelete').toString();
					super.showAlertModalWithErrorMessageList(errorMessage);
					this.isBusy = false;
				});
			}

			getOptionalParams() {
				return { isEditable: this.isEditableGroup(), identifier: this.getSelectedGroupIdentif() };
			}

			protected getSelectedGroupIdentif(): string {
				if (this.getSelectGroup().length > 0) {
					return this.getSelectGroup()[0].identifier;
				}
				return "";
			}

			protected getSelectedGroup(): string {
				if (this.getSelectGroup().length > 0) {
					return this.getSelectGroup()[0].id;
				}
				return "-1";
			}

			protected isEditableGroup(): boolean {
				if (this.getSelectGroup().length > 0) {
					return this.getSelectGroup()[0].isEditable;
				}
				return false;
			}

			private getSelectGroup(): any {
				var key = this.filters.filter((c: any) => c.key == 'groupIdentifier')[0].value;
				var listItems = this.enumsGroups.filter((c: any) => c.identifier == key);
				return listItems;
			}

			fetchData() {
				super.fetchData();
			}

			fetchDataFromServer(): Promise<AxiosResponse<any>> {
				let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, null, false);
				//return this.enumsService.getAllByFilter(enumsFilter);
				var res = this.enumsService.getAllByFilter(enumsFilter);
				res.then(() => {
					this.fetchAvailableEnumsList();
				});
				return res;
			}

			//zatím nepotrebujeme
			fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
				return this.fetchDataFromServer();
			}

			refreshItems(items: any[], refreshData: any[]) {
				return items;
			}

			first = "";

			groupsEnums = [{ value: '', text: '', description: '' }];
			//naplnění dropdownlistu číselník
			fetchAvailableEnumsList() {
				this.groupsEnums = [];
				this.isBusy = true;
				let enumsGroupsFilter: EnumsGroupsFilter = new EnumsGroupsFilter(null, null, true, this.$store.state.idTenant);
				this.enumsGroupsService.getAllByFilter(enumsGroupsFilter).then((response) => {
					this.enumsGroups = response.data;
					for (var i = 0; i < this.enumsGroups.length; i++) {
						this.groupsEnums.push({ value: this.enumsGroups[i].identifier, text: this.enumsGroups[i].name , description: this.enumsGroups[i].description });

					}

				
					if (this.groupsEnums.length > 0 && (this.filters.filter((c: any) => c.key == 'groupIdentifier')[0].value == '')) {
						this.defaultEnum = this.groupsEnums[0].value;
						var fil = this.filters.filter((c: any) => c.key == 'groupIdentifier')[0];
						fil.value = this.defaultEnum;
						fil.default = this.defaultEnum;
					}
					else {
						this.defaultEnum = this.filters.filter((c: any) => c.key == 'groupIdentifier')[0].value;
					}
					//nutny refesh
					this.setfilters(null);

				}).catch((error) => {
							this.isBusy = false;
							super.showErrorMessage(error);

						});
				this.isBusy = false;
			}
		

			sortEnumsBase() {
			  
				this.formData.id = 999;
				this.formData.idTenant = this.$store.state.idTenant;
				this.formData.idGroup = Number(this.enumsGroups.filter((c: any) => c.identifier == this.selectedIdentifier)[0].id);
				this.enumsService.update(999, this.formData).then(() => {
					this.fetchData();
				});
			}

			///formatovani vysledků
			prepareItems(items: any[]) {
				for (var i = 0; i < items.length; i++) {
					items[i].creationDate = new Date(items[i].creationDate).toLocaleDateString();
				}
			}
			setFields() {
			
				this.fields = [
					{ key: 'order', label: this.$t('enum.fieldOrder'), trans: 'enum.fieldOrder', sortable: true, class: 'text-left helpWidth80,  visibility: collapse', optional: false, show: this.isEditable, thClass: 'firstColumnTable' },
					{ key: 'groupIdentifier', label: 'identifier', sortable: true, class: 'text-left', show: false, thClass: 'firstColumnMichael' },
					{ key: 'name', label: this.$t('enum.fieldName'), trans: 'enum.fieldName', sortable: true, class: 'text-left', design: 'detail', thClass: 'firstColumnMichael' },
					{ key: 'description', label: this.$t('enum.fieldDescription'), trans: 'enum.fieldDescription', sortable: true, class: 'text-left' },
					//VaPTODO - nachystano v ramci pozadavku RM #352, ale zatim to zakaznikovi nebudeme nasazovat
					//{ key: 'order', label: 'Pořadí', sortable: true, class: 'text-center' },
					{ key: 'actions', label: this.$t('enum.fieldActions'), trans: 'enum.fieldActions', class: 'text-right', thClass: 'lastColumnMichael' }
				];
			}

			//filtry
			setfilters(value: any) {
			//	if (value != null && value[0].lang == this.filters[0].lang) { puvodni
				if (value != null ) {
					this.filters = value;
				}
				else {
					this.filters = [
						{
							key: 'groupIdentifier', label: this.$t('enum.filterType'), trans: 'enum.filterType', selected: true, value: this.defaultEnum, default: this.defaultEnum, type: 'text', useOwnEnumsSend: true,
							useOwnEnumsSendArray: this.groupsEnums, useEnum: true, refItem: 'groupIdentifier', showAnyTime: true, lang: this.$store.state.currentLanguage
						},
						{ key: 'name', label: this.$t('enum.filterName'), trans: 'enum.filterName', selected: false, value: null, type: 'text' },
						{ key: 'description', label: this.$t('enum.filterDescription'), trans: 'enum.filterDescription', selected: false, value: null, type: 'text' }
					];
				}
			}
			
	};